import { Stack } from '@koob/margaret';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { KoobButton, KoobInputTextareaField } from '@koob/ui';

const ConfirmAdminBookingForm = ({ onSubmit, onClose }) => {
  const { t } = useTranslation('bookings');

  return (
    <Formik
      initialValues={{ hotelKeeperMessage: '' }}
      validationSchema={Yup.object().shape({
        hotelKeeperMessage: Yup.string(),
      })}
      enableReinitialize
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Stack size="full" direction="column" paddingTop={1} gutterSize={2}>
            <KoobInputTextareaField
              name="hotelKeeperMessage"
              label={t('reason')}
              data-testid="confirm-booking-form-textarea"
            />
            <Stack size="full" alignX="flex-end" gutterSize={1}>
              <KoobButton type="button" variant="secondary" onClick={onClose}>
                {t('misc:cancel')}
              </KoobButton>
              <KoobButton
                variant="primary"
                loading={isSubmitting}
                type="submit"
                testId="confirm-booking-form-button"
              >
                {t('hotelKeeper:submit.confirm')}
              </KoobButton>
            </Stack>
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default ConfirmAdminBookingForm;
